var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-menu',{staticClass:"el-menu leftMenu",attrs:{"default-active":_vm.tacit,"active-text-color":"","text-color":"#6a6a6a","default-openeds":_vm.openeds},on:{"select":_vm.handleSelect}},[_c('el-menu-item-group')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eed77020","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/translate/components/incomeMenu.vue
// module id = null
// module chunks = 